import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { effect, Inject, Injectable, PLATFORM_ID, signal } from '@angular/core';

type AppTheme = 'light' | 'dark';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  darkModeEnabled = signal(false);
  private readonly isBrowser: boolean;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) platformId: object,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    const storedDarkModePreference: AppTheme | null = this.isBrowser
      ? (localStorage.getItem('theme') as AppTheme | null)
      : null;
    const darkModeEnabled = storedDarkModePreference === 'dark';
    this.darkModeEnabled.set(darkModeEnabled);
    effect(() => {
      const theme: AppTheme = this.darkModeEnabled() ? 'dark' : 'light';
      this.updateDarkModePreference(theme);
    });
  }

  toggleDarkMode() {
    const darkModeEnabled = !this.darkModeEnabled();
    this.darkModeEnabled.set(darkModeEnabled);
    this.toggleTheme();
  }

  toggleTheme(theme = null) {
    if (!this.isBrowser) {
      return;
    }

    const currentTheme =
      this.document.documentElement.getAttribute('data-theme');
    const newTheme = theme
      ? theme
      : currentTheme === 'shLight'
      ? 'shDark'
      : 'shLight';
    this.document.documentElement.setAttribute('data-theme', newTheme);
  }

  private updateDarkModePreference(theme: AppTheme) {
    if (!this.isBrowser) {
      return;
    }

    localStorage.setItem('theme', theme);
    this.document.documentElement.classList.toggle('dark', theme === 'dark');
  }
}
